import Head from "next/head";

import UPSMain from "@/components/fulfilment-partners/ups-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import { GetStaticProps } from "next";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";

export default function UPS({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <UPSMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_UPS },
  };
};
